// extracted by mini-css-extract-plugin
export default {"layout":"MobileLayout_layout__4wCUf","mockup":"MobileLayout_mockup__-G3h3","image":"MobileLayout_image__WsE2E"};